<template>
    <div style="width: 100%" class="bids-search">
        <div class="field is-horizontal" v-if="!isMobile">
            <div class="field-body">
                <incharge-select v-if="!isSalesStaff"></incharge-select>
                <div class="field text-center">
                    <div class="select is-fullwidth">
                        <select id="brands" v-model="query.brand">
                            <option :value="null" hidden disabled>Select brand</option>
                            <option v-for="brand in brands" :value="brand.label">
                                {{ brand.label }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="field text-right">
                    <div class="select is-primary is-fullwidth">
                        <select v-model="query.status">
                            <option :value="null" hidden disabled>Select Status</option>
                            <option :value="this.$bidStatusCancel">Canceled</option>
                            <option :value="this.$bidStatusActive">Active</option>
                            <option :value="this.$bidStatusWin">Win</option>
                            <option :value="this.$bidStatusLose">Lose</option>
                            <option :value="this.$bidStatusLoseToOtherUser">Lose to other</option>
                            <option :value="this.$bidStatusUnsold">Unsold</option>
                            <option :value="this.$bidStatusUnderNegotiations">Negotiations</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal" v-if="!isMobile">
            <div class="field-body">
                <div class="field">
                    <div class="select is-fullwidth">
                        <select id="auctions" v-model="query.auctions">
                            <option :value="null" disabled hidden>Select Auction</option>
                            <option v-for="auction in auctions"
                                    :value="auction.id">
                                {{ auction.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="field">
                    <p class="control is-expanded has-icons-left is-fullwidth">
                        <input v-model="query.chassis" class="input" type="text" placeholder="Chassis">
                        <span class="icon is-small is-left">
                      <i class="fas fa-hashtag"></i>
                    </span>
                    </p>
                </div>
                <div class="field">
                    <p class="control is-expanded has-icons-left is-fullwidth">
                        <input v-model="query.lots" class="input" type="text" placeholder="Lot#">
                        <span class="icon is-small is-left">
                      <i class="fas fa-gavel"></i>
                    </span>
                    </p>
                </div>
                <div class="field">
                    <p class="control is-expanded has-icons-left is-fullwidth">
                        <datetime
                                input-class="input"
                                v-model="bidDate"
                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                type="date"
                                value-zone="local"
                                zone="local"
                                placeholder="Select date"
                        ></datetime>
                        <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                    </p>
                </div>
                <div class="field text-right">
                    <div class="select is-primary is-fullwidth">
                        <select v-model="query.type">
                            <option :value="null" hidden disabled>Select Type</option>
                            <option :value="1">Automatic</option>
                            <option :value="2">Real</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="field is-horizontal" v-if="isMobile">
            <div class="field-body">
                <incharge-select></incharge-select>
                <div class="field text-center">
                    <div class="select is-fullwidth">
                        <select id="brands" v-model="query.brand">
                            <option :value="null" hidden disabled>Select brand</option>
                            <option v-for="brand in brands" :value="brand.label">
                                {{ brand.label }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal4" v-if="isMobile">
            <div class="field-body">
                <div class="field text-right">
                    <div class="select is-primary is-fullwidth">
                        <select v-model="query.status">
                            <option :value="null" hidden disabled>Select Status</option>
                            <option :value="this.$bidStatusCancel">Canceled</option>
                            <option :value="this.$bidStatusActive">Active</option>
                            <option :value="this.$bidStatusWin">Win</option>
                            <option :value="this.$bidStatusLose">Lose</option>
                            <option :value="this.$bidStatusLoseToOtherUser">Lose to other</option>
                            <option :value="this.$bidStatusUnsold">Unsold</option>
                            <option :value="this.$bidStatusUnderNegotiations">Negotiations</option>
                        </select>
                    </div>
                </div>
                <div class="field">
                    <div class="select is-fullwidth">
                        <select id="auctions" v-model="query.auctions">
                            <option :value="null" disabled hidden>Select Auction</option>
                            <option v-for="auction in auctions"
                                    :value="auction.id">
                                {{ auction.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal" v-if="isMobile">
            <div class="field-body">
                <div class="field">
                    <p class="control is-expanded has-icons-left is-fullwidth">
                        <input v-model="query.chassis" class="input" type="text" placeholder="Chassis">
                        <span class="icon is-small is-left">
                      <i class="fas fa-hashtag"></i>
                    </span>
                    </p>
                </div>
                <div class="field">
                    <p class="control is-expanded has-icons-left is-fullwidth">
                        <input v-model="query.lots" class="input" type="text" placeholder="Lot#">
                        <span class="icon is-small is-left">
                      <i class="fas fa-gavel"></i>
                    </span>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal last-row" v-if="isMobile">
            <div class="field-body">
                <div class="field">
                    <p class="control is-expanded has-icons-left is-fullwidth">
                        <datetime
                                input-class="input"
                                v-model="bidDate"
                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                type="date"
                                value-zone="local"
                                zone="local"
                                placeholder="Select date"
                        ></datetime>
                        <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                    </p>
                </div>
                <div class="field text-right">
                    <div class="select is-primary is-fullwidth">
                        <select v-model="query.type">
                            <option :value="null" hidden disabled>Select Type</option>
                            <option :value="1">Automatic</option>
                            <option :value="2">Real</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal last-row file is-centered mt-3 hero-buttons">
            <div class="field" style="padding-right: 20px;">
                <button class="button is-primary" @click.prevent="handleBidsSearch()">Search</button>
            </div>
            <div class="field">
                <button class="button" @click.prevent="clearForm()">Clear</button>
            </div>
        </div>
    </div>
</template>

<script>
    import apiAuctions from '../../api/apiAuctions'
    import InchargeSelect from './SearchInputs/InchargeSelect.vue'
    import moment from 'moment'
    import {Datetime} from 'vue-datetime'

    export default {
        components: {
            Datetime,
            InchargeSelect
        },
        data() {
            return {
                brands: [],
                auctions: [],
            }
        },
        methods: {
            clearForm() {
                this.$store.dispatch('clearBidsQuery')
                this.$store.dispatch('fetchBids')
            },
            handleBidsSearch() {
                this.$store.dispatch('fetchBidsWithSearchQuery')
            }
        },
        computed: {
            query() {
                return this.$store.getters.getBidsQuery
            },
            isUserSinglePage() {
                return location.pathname.split('/')[1] !== 'users'
            },
            bidDate: {
                get() {
                    return this.$store.getters.getBidsQuery.date
                },
                set(value) {
                    this.$store.dispatch('setBidsNewQueryDate', value)
                }
            },
            isMobile() {
                return (window.innerWidth <= 760)
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        },
        created() {
            this.brands = apiAuctions.getCarBrands()
            apiAuctions
                .getAuctionsData()
                .then((response) => {
                    this.auctions = response.data.auctions
                })
                .catch((error) => {
                    console.log(error)
                })
            let date = new Date()
            date = moment(date).format('Y-MM-DD')
            this.$store.dispatch('setBidsNewQueryDate', date)
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Bids/BidsSearch.vue